export const localeContext = "wx-i18n";
//# sourceMappingURL=index.js.map